export default __webpack_public_path__ + "static/media/office-building.fc797a2c.png";